import { HomeView } from '@zmedia/bm-soccer-ui/modules';
import LayoutApp from '@zmedia/bm-soccer-ui/layout';
import PageCustomService from '@zmedia/bm-soccer-ui/service/PageCustomService';
import { GetServerSidePropsContext } from 'next';
import { IResponse } from 'src/interface';
import { ContainerUI } from 'src/layout/ui';
import { ContentItem } from 'src/modules/content/components/item/ContentItem';

export function Home({
    resp,
    isBot,
}: {
    resp: IResponse<any>;
    isBot: boolean;
}) {
    const { data } = resp;
    const listProps = {
        ContentItem: ContentItem,
        ContentItemProps: {
            lazyloadImage: !isBot,
            showDescription: isBot,
            truncateDescription: !isBot,
        },
    };
    return (
        <>
            <ContainerUI page="home-soccer" />
            <LayoutApp page="home-soccer" isMobile={true}>
                <HomeView {...data.content} listProps={listProps} />
            </LayoutApp>
        </>
    );
}

export async function getServerSideProps(
    ctx: GetServerSidePropsContext
): Promise<any> {
    const resp = await PageCustomService.get(ctx, 'wap/home');
    return {
        props: {
            ...resp.props,
            isBlankLayout: true,
        },
    };
}

export default Home;
